// extracted by mini-css-extract-plugin
export default {"Heading":"Heading_Heading__ddKWP"};